var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.158,
    height: 28.158,
    viewBox: "0 0 28.158 28.158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Insta",
    d: "M117.258,200.721a7.625,7.625,0,0,0-7.621-7.621H96.721a7.625,7.625,0,0,0-7.621,7.621v12.917a7.625,7.625,0,0,0,7.621,7.621h12.917a7.625,7.625,0,0,0,7.621-7.621Zm-2.325,0v12.917a5.3,5.3,0,0,1-5.3,5.3H96.721a5.3,5.3,0,0,1-5.3-5.3V200.721a5.3,5.3,0,0,1,5.3-5.3h12.917A5.3,5.3,0,0,1,114.933,200.721Zm-5.438,5.474a6.341,6.341,0,0,0-5.332-5.332,6.2,6.2,0,0,0-.929-.068,6.329,6.329,0,1,0,6.329,6.329A6.2,6.2,0,0,0,109.5,206.195Zm-2.3.341a4.074,4.074,0,0,1,.043.588,4,4,0,1,1-4-4,4.077,4.077,0,0,1,.588.043A4.015,4.015,0,0,1,107.2,206.536Zm3.087-7.623a1.162,1.162,0,1,1-1.163,1.162A1.163,1.163,0,0,1,110.283,198.913Z",
    transform: "translate(-89.1 -193.1)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/Insta.8c6198d3bd9f6483c72b7d3cdb2ae0d1.svg";
export { ForwardRef as ReactComponent };